export default "__VITE_ASSET__DshSfUpW__"